import { useLocation } from 'react-router-dom';

import Typography from '~/shared/components/Typography';

import ProfileDropdown from './ProfileDropdown';
import { sidebarItems } from './common';

export default function Header() {
  const { pathname } = useLocation();

  const title = sidebarItems.find((item) => pathname.startsWith(item.pathname))?.title;

  return (
    <div className="px-[22px] min-h-[88px] h-[88px] flex justify-between items-center">
      <Typography variant="H3" color="text-white">
        {title || null}
      </Typography>

      <ProfileDropdown />
    </div>
  );
}
